"use client";

import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, Media, Separator, TextBody, TextHeading } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { MAX_MINTABLE_MAX } from "@/components/collection/drops/constants";
import { useDropStore } from "../CollectionDropContext";
import { MintOptionsPicker } from "../MintOptionsPicker";
import { StagePriceDisplay } from "../StagePriceDisplay";
export function MintOptionsModule(t0) {
  const $ = _c(32);
  const {
    isPreview
  } = t0;
  const t = useTranslations("MintOptionsModule");
  const currentStage = useDropStore(useShallow(_temp));
  const showPerWalletLimit = currentStage?.maxTotalMintableByWallet !== MAX_MINTABLE_MAX;
  if (!currentStage) {
    return null;
  }
  let t1;
  if ($[0] !== currentStage.label) {
    t1 = <TextHeading size="sm">{currentStage.label}</TextHeading>;
    $[0] = currentStage.label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentStage) {
    t2 = <TextHeading className="font-mono" size="sm"><StagePriceDisplay stage={currentStage} /></TextHeading>;
    $[2] = currentStage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <FlexColumn className="gap-2 md:flex-row md:items-center md:justify-between">{t1}{t2}</FlexColumn>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== currentStage.maxTotalMintableByWallet || $[8] !== showPerWalletLimit || $[9] !== t) {
    t4 = showPerWalletLimit ? <><TextBody className="font-mono uppercase" color="text-tertiary" size="sm" weight="semibold">{t("totalLimit", {
          max: currentStage.maxTotalMintableByWallet
        })}</TextBody><Media greaterThanOrEqual="md"><Separator className="h-3" orientation="vertical" /></Media></> : null;
    $[7] = currentStage.maxTotalMintableByWallet;
    $[8] = showPerWalletLimit;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="size-2 animate-pulse rounded-full bg-success-1" />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("mintingNow");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <Flex className="items-center gap-2">{t5}<TextBody className="font-mono text-success-1 uppercase" size="sm">{t6}</TextBody></Flex>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <FlexColumn className="gap-2 md:flex-row md:items-center md:justify-start">{t4}{t7}</FlexColumn>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== currentStage) {
    t9 = <TextBody className="font-mono" color="text-secondary"><StagePriceDisplay display="secondary" stage={currentStage} /></TextBody>;
    $[19] = currentStage;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <FlexColumn className="flex-col-reverse gap-2 md:flex-row md:items-center md:justify-between">{t8}{t9}</FlexColumn>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t3) {
    t11 = <FlexColumn className="gap-2">{t3}{t10}</FlexColumn>;
    $[24] = t10;
    $[25] = t3;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== isPreview) {
    t12 = isPreview ? null : <MintOptionsPicker />;
    $[27] = isPreview;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12) {
    t13 = <FlexColumn className="w-full rounded-md border border-border-1 bg-bg-secondary p-6">{t11}{t12}</FlexColumn>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
function _temp(state) {
  const current = state.stages.find(stage => stage.stageIndex === state.activeStageIndex) || null;
  return current;
}